import { render } from "./LanguageCard.vue?vue&type=template&id=229f8298&scoped=true"
import script from "./LanguageCard.vue?vue&type=script&lang=js"
export * from "./LanguageCard.vue?vue&type=script&lang=js"

import "./LanguageCard.vue?vue&type=style&index=0&id=229f8298&scoped=true&lang=stylus"
script.render = render
script.__scopeId = "data-v-229f8298"

export default script